module.exports = __webpack_public_path__ + "static/media/laser_2016.1fcf1489.jpg";